<div
    class="flex flex-col md:flex-row justify-between items-center bg-gray-50 dark:bg-[#19191c] p-6 rounded-xl shadow-xl space-y-4 md:space-y-0">
    <div class="text-gray-800 text-base leading-tight md:text-left text-center">
        <div class="font-semibold text-lg dark:text-white">Gerenciamientos Retrasados (Sin Cerrar)</div>
    </div>

    <div class="md:grow md:flex md:justify-center w-full">
        <button
            class="bg-[#2563eb] hover:bg-blue-700 text-white font-medium py-2 px-6 mr-[6rem] rounded-md shadow transition duration-200 w-full md:w-auto"
            (click)="toAdd()">
            Crear Nuevo Gerenciamiento
        </button>
    </div>

    <div class="w-full md:w-auto">
        <button type="button"
            class="flex items-center justify-center border border-cyan-600 hover:shadow-lg hover:shadow-[#63cbe0] hover:bg-cyan-500 hover:text-white px-4 py-2 text-md font-medium text-cyan-600 dark:text-cyan-300 rounded-md shadow-sm transition duration-200 w-full md:w-auto"
            (click)="abrirDialogo()">
            Ver Gerenciamientos
        </button>
    </div>
</div>

<p-dialog header="Gerenciamientos Retrasados" [(visible)]="showDialogo" [modal]="true"
    [style]="{ width: '90%', 'max-width': '1200px' }" [resizable]="false" [closable]="true">
    <div class="bg-white dark:bg-[#19191c] p-6 rounded shadow-sm mb-6 overflow-x-auto">
        <p-table [value]="datosTabla" [tableStyle]="{ 'min-width': '700px', 'min-height': '300px' }"
            [ngClass]="{ 'blur-sm opacity-60': showPopover }">
            <ng-template pTemplate="header">
                <tr>
                    <th>ID</th>
                    <th>Origen</th>
                    <th>Destino</th>
                    <th>Conductor</th>
                    <th>Fecha/Hora Partida</th>
                    <th>Fecha/Hora Llegada</th>
                    <th>Estado
                        <i class="pi pi-question text-white bg-blue-600 p-2 rounded"
                            (click)="togglePopover($event, overlayAyuda)"></i>
                        <p-popover class="p-4" #overlayAyuda [dismissable]="true"
                            [style]="{ width: '90%', 'max-width': '670px' }" appendTo="body">
                            <p>En esta tabla podrás ver los gerenciamientos "ACTIVOS". Para que un gerenciamiento se
                                considere "ACTIVO" debe estar "AUTORIZADO" y se debe encontrar "ABIERTO".</p>
                            <p><span class="text-green-600 font-semibold">EN PROGRESO</span> - El gerenciamiento se
                                encuentra dentro
                                del limite de tiempo de llegada.</p>
                            <p><span class="text-yellow-600 font-semibold">DEMORA</span> - El gerenciamiento se
                                encuentra 1 hora por
                                fuera del limite de tiempo de llegada.</p>
                            <p><span class="text-red-600 font-semibold">RETRASO</span> - El gerenciamiento se encuentra
                                2 horas por
                                fuera del limite de tiempo de llegada.</p>
                            <p>Tenga en cuenta que sólo se muestran los últimos 1000 registros.</p>
                            <p class="text-sm text-gray-600">(Para visualizarlos todos ir a ">Crear Gerenciamiento
                                >Historico", Busqueda
                                avanzada y filtrar ">Autorizacion >Autorizado" y ">Estado >Abierto".)</p>
                        </p-popover>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-doc>
                <tr>
                    <td>{{ doc.id }}</td>
                    <td>{{ doc.origen }}</td>
                    <td>{{ doc.destino }}</td>
                    <td>{{ doc.conductor }}</td>
                    <td>{{ doc.fechaPartida }}</td>
                    <td>{{ doc.fechaLlegada }}</td>
                    <td
                        [ngStyle]="{ color: doc.estado === 'RETRASADO' ? 'red' : doc.estado === 'DEMORA' ? 'orange' : 'green' }">
                        {{ doc.estado }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-dialog>